<template>
    <div id="layout">
        <transition name="slide-fade" mode="out-in" appear>
            <router-view :data_fetched="data_fetched">
            </router-view>
        </transition>

        <div is="BackToTopButton"></div>
    </div>
</template>

<script>
import BackToTopButton from '@toolbox/back_to_top_button/main.vue'
export default {
    name: "PermissionGroupsLayout",
    props: {
        is_layout_data_fetched: Boolean
    },
    data: function() {
        return {
            errors: [],
            data_fetched: false,
        }
    },
    computed: {
    },
    created: function() {
    },
    mounted: function() {
        var that = this;
        that.init();

        that.$bus.$off('init');
        that.$bus.$on('init', function(value = false) {
            that.init();
        }.bind(this));

        // pagination channel
        that.$bus.$off('index_page');
        that.$bus.$on('index_page', function(page) {
            that.$store.state.provider.permission_groups_module.current_page = page;
            that.get_permission_groups(page);
        }.bind(this));
    },
    beforeDestroy: function() {
        this.$bus.$off('init');
    },
    watch: {
        is_layout_data_fetched: function(value) {
            var that = this;

            if (value) {
                that.init();
            }
        },
    },
    methods: {
        refresh: function() {
            location.reload();
        },
        init: async function() {
            var that = this;
            try {
                await new Promise(resolve => {
                    that.is_initialized = false;
                    resolve();
                });
                await that.get_permissions();
                await that.get_permission_groups();
                await new Promise(resolve => {
                    that.is_initialized = true;
                    that.$noty.information(
                        that.$t("ui.page_titles.permission_groups") + ' ' +
                        that.$t('ui.general.initialize_complete')
                    , 300);
                    resolve();
                });
            } catch (err) {
                console.log(err);
            }
        },
        get_permissions: function() {
            var that = this;

            var url = that.$store.state.provider.routes.api_v1_provider_permissions;

            that.is_initializing = true;
            axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    if (response.data.status == "success") {
                        var permissions = _.remove(response.data.permissions, function(permission) {
                            return (
                                permission.name != "api_v1_provider_me" &&
                                permission.name != "api_v1_provider_routes"
                            )
                        });
                        that.$store.state.provider.permission_groups_module.permissions = permissions ;

                    } else {
                        // that.$noty.error('無法取得permissions 權限列表');
                        that.$noty.error(
                            that.$t('ui.notifications.error.fetch__name', {
                                name: that.$t('models.permissionss')
                            })
                        );
                    }
                    that.is_initializing = false;
                })
                .catch(function (error) {
                    // that.$noty.error('取得permissions失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.fetch__name', {
                            name: that.$t('models.permissionss'),
                            reason: ': ' + error
                        })
                    );
                    that.is_initializing = false;
                });

        },
        get_permission_groups: function(page = 1) {
            var that = this;

            var url = that.$store.state.provider.routes.api_v1_provider_permission_groups + "?page=";

            url = (page)
                ? url + page
                : url + that.$store.state.provider.permission_groups_module.current_page ;

            if (that.search) {
                url = url + "&search=" + that.search;
            }

            that.is_initializing = true;
            axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    if (response.data.status == "success") {
                        var permission_groups_module = that.$store.state.provider.permission_groups_module;
                        permission_groups_module.permission_groups = response.data.permission_groups;
                        permission_groups_module.current_page = response.data.pagination.current_page;
                        permission_groups_module.total_pages = response.data.pagination.total_pages;
                        that.data_fetched = true;
                    } else {
                        // that.$noty.error('無法取得permission_groups 權限群組列表');
                        that.$noty.error(
                            that.$t('ui.notifications.error.fetch__name', {
                                name: that.$t('models.permission_groups')
                            })
                        );
                    }
                    that.is_initializing = false;
                })
                .catch(function (error) {
                    // that.$noty.error('取得permission_groups失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.fetch__name', {
                            name: that.$t('models.permission_groups'),
                            reason: ': ' + error
                        })
                    );
                    that.is_initializing = false;
                });

        },
    },
    components: {
        BackToTopButton
    }
}
</script>
<style lang="scss">
    @import "../.assets/stylesheets/layout.scss";
</style>
